import React from 'react';
 // Importing the Navbar we built earlier
import './HeroSection.css';
import NavBar from '../navbar/NavBar';

const HeroSection = () => {
  return (
    <div className="hero-container">
      {/* 1. The Navigation Bar floats on top */}
      <NavBar/>

      {/* 2. The Main Hero Content */}
      <div className="hero-content">
        
        {/* The Floating Glass Card with Large Logo */}
        <div className="hero-glass-card">
          <div className="card-logo-icon">
          <img 
          src="/logo.png" 
          alt="Sry Interiors Logo" 
          className="logo-image" 
        />
          </div>
          <h1 className="hero-title">SRY</h1>
          <p className="hero-subtitle">INTERIORS</p>
        </div>

      </div>
    </div>
  );
};

export default HeroSection;